<template>
  <loading
    color="#4e46dc"
    v-model:active="loading.addToCart"
    transition="disappear"
    :can-cancel="false"
    :is-full-page="true"
  />
  <header class="header" :style="{ 'background-image': `url(${heroImage})` }">
    <div class="header-content">
      <h1 class="header-title">{{ getTitleByLang }}</h1>
    </div>
  </header>
  <div class="container mt-7 mx-auto px-4 sm:py-8 sm:container sm:mx-auto">
    <div class="cols2grid">
      <div class="desc" :class="{ expanded: showFullDescription }">
        <p ref="desc" :class="{ 'trimmed-text': !showFullDescription }" v-html="getDescByLang"></p>
        <button
          v-if="shouldShowButton"
          @click="toggleDescription"
          class="read-more-btn"
        >
          {{ showFullDescription ? $t('read_less') : $t('read_more') }}
        </button>
      </div>
      <div class="info">
        <div class="venue mb-4" v-if="museumExtraJson.address != null">
          <div class="flex mb-2"><i data-feather="map-pin" class="w-5 text-gray-500 dark:text-gray-400 mr-4"></i>{{museumExtraJson.address}}</div>
          <button v-if="museumExtraJson.coords != null"><a target="_new" :href="`https://www.google.com/maps?q=${museumExtraJson.coords}`">Vezi pe harta</a></button>
        </div>
        <div v-if="images != null" class="gallery">
        <div class="gallery-item">
          <img
            :src="selectedImage.url"
            :alt="selectedImage.alt != null ? selectedImage.alt : museum.title"
            class="gallery-image"
            @click="openLightbox(selectedImage)"
          />
        </div>
        <div v-if="images.length > 1" class="thumbnails">
          <div class="thumbnail-item" v-for="image in images" :key="image.id">
            <img
              :src="image.url"
              :alt="image.alt != null ? image.alt : museum.title"
              class="thumbnail-image"
              @click="showImage(image)"
            />
          </div>
        </div>
        <div
          class="lightbox-overlay"
          v-if="showLightbox"
          @click="closeLightbox"
        >
          <div class="lightbox-content">
            <span class="lightbox-close" @click="closeLightbox">&times;</span>
            <img
              :src="selectedImage.url"
              :alt="selectedImage.alt"
              class="lightbox-image"
            />
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="cols2grid wrapper mt-4">
      <div class="ticketslist">
        <div v-show="loading.dates || showCalendar">
          <h2 class="text-xl font-bold mb-2 mt-4" style="margin-bottom: 20px">
            {{ $t('select_date') }}
          </h2>
          <loading
            class="vl-parent"
            color="#4e46dc"
            v-model:active="loading.dates"
            transition="disappear"
            :can-cancel="false"
            :is-full-page="false"
          />
          <div class="calendar" v-if="!loading.dates">
            <button
              style="
                border: 1px solid #e4daff;
                border-radius: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
                min-width: 120px;
              "
              v-if="showTodayButton"
              :class="{ 'bg-purple-500 text-white': isTodaySelected }"
              @click="selectToday"
            >
              Astăzi
            </button>
            <button
              style="
                border: 1px solid #e4daff;
                border-radius: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 50px;
                min-width: 120px;
              "
              v-if="showTomorrowButton"
              :class="{ 'bg-purple-500 text-white': isTomorrowSelected }"
              @click="selectTomorrow"
            >
              Mâine
            </button>
            <div style="width: 250px">
              <VDatePicker
                locale="ro"
                highlight="true"
                v-model="selectedDate"
                mode="single"
                :attributes="calendarAttributes"
                :disabled-dates="disableDates"
                is-inline
                :min-date="minDate"
                :max-date="maxDate"
              ></VDatePicker>
            </div>
          </div>
        </div>
        <div v-if="selectedDateEvents.length > 0" ref="tickets-select">
          <h2 class="text-xl font-bold mb-2 mt-6" style="margin-bottom: 20px">
            {{$t('select_tickets')}}
          </h2>
          <loading
            class="vl-parent"
            color="#4e46dc"
            v-model:active="loading.selectDate"
            transition="disappear"
            :can-cancel="false"
            :is-full-page="false"
          />
          <div
            v-show="loading.selectDate == false"
            v-for="event in selectedDateEvents"
            :key="event.id"
            style="
              border: 1px solid #e4daff;
              border-radius: 20px;
              padding: 20px 40px;
              margin-bottom: 20px;
            "
          >
            <div class="text-left">
              <div class="text-xl">{{ $t(event.name) }}</div>
              <div>
                <p :ref="'event-desc-' + event.id" class="font-size-80 mb-4 mt-1" :class="{ 'trimmed-text-min': !evShowMoreArray[event.id] }" v-html="event.description"> 
                </p>
                <button
                  v-show="evDescArray[event.id] != null && evDescArray[event.id]"
                  @click="toggleEventDesc(event)"
                  class="read-more-event-btn"
                >
                {{ evShowMoreArray[event.id] ? $t('read_less') : $t('read_more') }}
                </button>
              </div>
              <div
                class="flex flex-wrap gap-4 items-center"
                v-if="event.instances.length <= 4"
              >
                <div v-if="event.dateVisibility == 0 && !singleEventInstance" class="text-lg">{{event.instances[0].dateEnd != null ? $t('access_interval') : $t('hour')}}:</div>
                <div v-if="event.dateVisibility == 0 && singleEventInstance" class="text-lg">{{event.instances[0].dateEnd != null ? $t('access_interval_date') : $t('date')}}:</div>
                <div v-for="instance in event.instances" :key="instance.id">
                  <div v-if="instance.dateVisibility == 1" class="mb-4">{{formatEiDate(instance)}}</div>
                  <button
                    :disabled="instance.ticketsLeft <= 0"
                    @click="selectEi(event.id, instance.id)"
                    type="button"
                    class="text-white bg-purple-700 hover:bg-purple-800 focus:outline-none font-medium rounded-full text-sm px-5 py-1,7 text-center"
                    :class="{
                      'ei-active': selectedEi && selectedEi.eiId == instance.id,
                      'last-tickets': instance.ticketsLeft > 0 && instance.ticketsLeft < LAST_TICKETS
                    }"
                  >
                    <span v-if="instance.dateVisibility == 0 && !singleEventInstance"> {{ formatEiHour(instance) }} <span v-if="instance.ticketsLeft <= 0" style="font-size: 90%;">{{ $t('sold_out') }} </span> <span v-if="instance.ticketsLeft > 0 && instance.ticketsLeft <= LAST_TICKETS" style="font-size: 90%;">{{ $t('last_tickets') }}</span></span>
                    <span v-if="instance.dateVisibility == 0 && singleEventInstance"> {{ formatEiDate(instance) }} {{ formatEiHour(instance) }} <span v-if="instance.ticketsLeft <= 0" style="font-size: 90%;">{{ $t('sold_out') }} </span> <span v-if="instance.ticketsLeft > 0 && instance.ticketsLeft <= LAST_TICKETS" style="font-size: 90%;">{{ $t('last_tickets') }}</span></span>
                    <span v-if="instance.dateVisibility > 0"> {{ $t('pick_tickets') }}</span>
                  </button>
                </div>
              </div>
              <div class="flex gap-4 items-center" v-else>
                <!-- Render select list when there are more than 4 instances -->
                <div class="text-lg">{{ $t('access_interval') }}:</div>
                <select
                  style="min-width: 150px"
                  @change="selectEi(selectedHour.eId, selectedHour.eiId)"
                  v-model="selectedHour"
                  class="appearance-none bg-white border border-gray-300 py-2 px-3 rounded-md shadow-sm text-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <option value="null">{{ $t('pick_hour') }}</option>
                  <option
                    :disabled="instance.ticketsLeft <= 0"
                    v-for="instance in event.instances"
                    :key="`${event.id}-${instance.id}`"
                    :value="{ eiId: instance.id, eId: event.id }"
                  >
                    {{ formatEiHour(instance) }} <span v-if="instance.ticketsLeft <= 0"> - {{ $t('sold_out') }} </span> <span v-if="instance.ticketsLeft > 0 && instance.ticketsLeft <= LAST_TICKETS"> - {{ $t('last_tickets') }}</span>
                  </option>
                </select>
              </div>
              <div v-if="selectedEi && selectedEi.eId == event.id">
                <div v-if="showSelectionTypes" class="flex gap-2 mt-4">
                  <button class="bg-primary-muzeu text-white font-bold p-2 px-4 mr-2 rounded-md"
                    :disabled="selectionType == 0"
                    @click="setSelectionType(0)">
                    <span class="font-bold">{{ $t('automatic_selection') }}</span>
                  </button>
                  <button class="bg-primary-muzeu text-white font-bold p-2 px-4 rounded-md"
                    :disabled="selectionType == 1"
                    @click="setSelectionType(1)">
                    <span class="font-bold">{{ $t('manual_selection') }}</span>
                  </button>
                </div>
                <div
                v-show="selectionType == 0"
                 class="details, selected mt-4">
                  <div class="price-entities">
                  <div class="price-entity" v-for="(price, index) in selectedEi.prices" :key="index">
                    <div class="flex justify-between items-center">
                      <div>
                      {{ $t(price.name) }} - {{ price.price }} RON
                    <div class="font-size-80">
                      {{ price.description }}
                    </div>
                      </div>
                      <div class="flex items-center">
                        <button
                          :disabled="price.availableSeats <= 0"
                          @click="
                            price.quantity > 1
                              ? price.quantity--
                              : (price.quantity = 0)
                          "
                          class="bg-gray-300 text-gray-800 font-bold px-2 py-1 rounded-l focus:outline-none"
                        >
                          -
                        </button>
                        <input
                        :disabled="price.availableSeats <= 0"
                          v-model="price.quantity"
                          type="number"
                          min="0"
                          max="999"
                          style="width: 47px"
                          class="text-center text-gray-700 font-bold h-8 border-t border-b border-gray-300"
                          ref="quantityInput"
                        />
                        <button
                          :disabled="price.availableSeats <= 0"
                          @click="price.quantity++"
                          class="bg-gray-300 text-gray-800 font-bold px-2 py-1 rounded-r focus:outline-none"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div style="text-align: center">
                    <button
                      v-if="showAddToCart"
                      @click="addToCart(instance, category, promotion)"
                      class="bg-primary-muzeu text-white font-bold px-2 py-1"
                      style="border-radius: 20px; padding: 10px 30px"
                    >
                      <div class="flex align-center">
                        <span class="mr-1">{{ $t('add_to_cart') }}</span>
                      </div>
                    </button>
                  </div>
                </div>
                <div
                  v-show="selectionType == 1"
                  class="details, selected mt-4">
                  
                  <VenueVisualizer
                    v-if="venue != null"
                    ref="venueVisualizer"
                    :key="venueTimestamp"
                    :current-user-id="getUser ? getUser.userId : -1"
                    class="relative-position venue-visualizer"
                    :sectionId="-1"
                    :onClickSeat="onClickSeat"
                    v-model:section="venue"
                    :onSelectFromFlatSection="onSelectFromFlatSection"
                    :findSectionCategory="findSectionCategory"
                    :noTickets="numberOfSeatsUserWishesToPurchase"
                    :actualReservedSeats="actualSelectedSeats"
                    :addToReservedSeats="addToSelectedSeats"
                    :clearReservedSeats="clearReservedSeats"
                    :totalSeatsCost="totalSeatsCost"
                    :reservedSeatsCurrency="selectedSeatsCurrency"
                    :newFormat="venue.nf"
                  />

                  <div
                    v-if="actualSelectedSeats.length > 0"
                    class="relative bg-white p-4 rounded-md shadow-md selected-seats-summary"
                  >
                    <div>
                      <div class="text-center mb-4">
                        <div class="text-lg font-bold">{{ $t('youveSelected') }}</div>
                        <!--<div class="font-bold">{{ eventTitle }}</div>
                        <div v-if="showInterval">
                          {{ $i18nFormat.formatEventDateInterval(selectedInstance.dateStart, selectedInstance.dateEnd) }}
                        </div>
                        <div v-if="!showInterval && showDate && showTime">
                          {{ $i18nFormat.formatEventDate(selectedInstance.dateStart) }}
                          {{ $i18nFormat.formatEventHour(selectedInstance.dateStart) }}
                        </div>
                        <div v-if="!showInterval && showDate && !showTime">
                          {{ $i18nFormat.formatEventDate(selectedInstance.dateStart) }}
                        </div>
                        <div v-if="showAddress && showCity" class="text-sm text-gray-500">
                          {{ selectedInstance.venue.name }}, {{ selectedInstance.venue.address }}, {{ selectedInstance.venue.city }}
                        </div>
                        <div v-if="showAddress && !showCity" class="text-sm text-gray-500">
                          {{ selectedInstance.venue.name }}, {{ selectedInstance.venue.address }}
                        </div>
                        <div v-if="!showAddress && !showCity" class="text-sm text-gray-500">
                          {{ selectedInstance.venue.name }}
                        </div>-->
                      </div>

                      <hr class="border-gray-300 my-4" />

                      <table class="table-auto w-full text-left">
                        <tbody>
                          <tr v-for="seat in actualSelectedSeats" :key="seat.id" class="border-b">
                            <td class="py-2">
                              <div
                                class="w-6 h-6 rounded-full"
                                :style="{ backgroundColor: getSeatPcd(seat).color }"
                              ></div>
                            </td>
                            <td class="py-2">
                              <span class="font-medium">{{ getSeatLabel(seat) }}</span>
                              <span v-if="seat.lowVisibility" class="text-sm text-gray-500">
                                ({{ $t('tickets.lowVisibility') }})
                              </span>
                              <span class="text-sm text-gray-500">
                                - {{ seatCost(seat) }} {{ getSeatPcd(seat).currency }}
                              </span>
                            </td>
                            <td class="py-2">
                              <select
                                v-if="getPromotionForSeatId(seat.id).length && !multiplePromotionSelected"
                                class="border rounded-md p-1 text-sm"
                                v-model="seat.promotion"
                                @change="onSelectSingleSeatPromotion(seat.id, $event.target.value)"
                              >
                                <option
                                  v-for="promo in getPromotionForSeatId(seat.id)"
                                  :key="promo.name"
                                  :value="promo.name"
                                >
                                  {{ promo.name }}
                                </option>
                              </select>
                            </td>
                            <td class="py-2">
                              <button
                                @click="removeSelectedSeat(seat)"
                                class="text-red-500 hover:text-red-700"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-5 w-5"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                  />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <hr class="border-gray-300 my-4" />

                     <!--  <div v-if="promotions && promotions.multiple && promotions.multiple.length" class="mt-4">
                        <select
                          class="border rounded-md p-2 w-full"
                          v-model="multiplePromotionSelected"
                          @change="onSelectMultiplePromotion($event.target.value)"
                        >
                          <option value="" disabled>{{ $t('event.pickPromo') }}</option>
                          <option
                            v-for="promo in promotions.multiple"
                            :key="promo.name"
                            :value="promo"
                          >
                            {{ promo.name }} - {{ promo.description }}
                          </option>
                        </select>
                      </div> -->

                     <!--  <div v-if="Object.keys(promotionDetails).length > 0" class="mt-4">
                        <div v-for="(promo, index) in promotionDetails" :key="index">
                          <div class="text-lg font-bold">{{ promo.name }}</div>
                          <div class="text-sm text-gray-500">{{ promo.mention }}</div>
                        </div>
                      </div> -->

                      <div class="mt-4">
                        <div class="text-lg font-bold">
                          {{ capitalized($t('total')) }}: {{ totalSeatsCost }} {{ selectedSeatsCurrency }}
                        </div>
                      </div>

                      <div style="text-align: center">
                        <button
                          :disabled="reservingTickets"
                          @click="onClickAddTicketsToCart"
                          class="bg-primary-muzeu text-white font-bold px-2 py-1"
                          style="border-radius: 20px; padding: 10px 30px"
                        >
                          <div class="flex align-center">
                            <span class="mr-1">{{ $t('add_to_cart') }}</span>
                          </div>
                        </button>
                      </div>

                      <div v-if="reservingTickets" class="flex justify-center mt-4">
                        <svg
                          class="animate-spin h-8 w-8 text-blue-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                          ></circle>
                          <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8H4z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="shoppingcart rcol mt-4">
        <Cart :tickets="this.getCartTickets"> </Cart>
      </div>
    </div>
  </div>
  <InfoModal
    ref="fewerTicketsModal"
  >
    <template #title>{{ $t('could_not_select_all') }}</template>
    <template #default>
      {{ $t('info_fewer_tickets') }}
    </template>
  </InfoModal>
  <InfoModal
    ref="noTicketsModal"
  >
    <template #title>{{ $t('could_not_select') }}</template>
    <template #default>
      {{ $t('info_no_tickets') }}
    </template>
  </InfoModal>
</template>
  
<script>
import Cart from "./Cart.vue";
import Loading from "vue-loading-overlay";
import { mapGetters, mapActions } from "vuex";
import { capitalized, delay } from "../mixins/utils";
import { formatHour, formatEiHour, formatEiDateFull, sameDay, formatEiDate } from "../mixins/dateformats";
import { useHead } from "@vueuse/head";
import feather from 'feather-icons';
import InfoModal from "../components/InfoModal.vue"; 
import VenueVisualizer from "../components/VenueVisualizer.vue";
import { showToast } from '../mixins/toast';

const EI_SHOW_HOUR = 0;
const EI_SHOW_DATE = 1;
const EI_SHOW_NOTHING = 2;
const TICKET_FREE = 0, TICKET_DIRTY = 10;
const MAX_SELECT_TICKETS = 100; //TODO - this should be a config value

export default {
  components: {
    Cart,
    Loading,
    InfoModal,
    VenueVisualizer
  },
  data() {
    return {
      loading: {
        dates: true,
        selectDate: false,
        addToCart: false,
      },
      selectedHour: null,
      museum: {},
      events: [],
      eiids: null,
      selectedDate: null,
      selectedEi: null,
      allowedDates: [],
      cartItems: [],
      isTodaySelected: false,
      isTomorrowSelected: false,
      today: new Date(),
      showFullDescription: false,
      shouldShowButton: false,
      showLightbox: false,
      selectedImage: null,
      showCalendar: false,
      descComputed: false,
      evDescArray: [],
      evShowMoreArray: [],
      LAST_TICKETS: 10,
      singleEventInstance: false,
      selectionType: null, // 0 - automatic, 1 - manual
      showSelectionTypes: null,
      venue: null,
      venueTimestamp: 0,
      actualSelectedSeats: [],
      priceCategories: [],
      promotions: null,
      multiplePromotionSelected: null
    };
  },
  methods: {
    ...mapActions(['selectSeat','deselectSeat','addPromotion','getEventInstancePrices','getSeatPromotions','addSeatsToCart']),
    capitalized,
    delay,
    formatHour,
    formatEiHour,
    formatEiDateFull,
    formatEiDate,
    sameDay,
    async selectEi(eventId, instanceId) {
      if (this.selectedEi != null && this.selectedEi.eiId == instanceId) {
        // Already selected, do nothing
        return;
      }
      console.log("selectEi", eventId, instanceId);
      let event = null, instance = null;
      event = this.events.find(e => e.id == eventId);
      if (event == null){
        return;
      }
      instance = event.instances.find(ei => ei.id == instanceId);
      if (event == null){
        return;
      }
      if (this.selectedHour == null) {
        this.selectedHour = { eiId: instance.id, eId: event.id };
      }
      this.selectedEi = this.createSelectedEiObj(event, instance);
      this.showSelectionTypes = false;
      if (this.selectedEi.manualSelection) {
        this.showSelectionTypes = true;
      } else {
        this.selectionType = 0;
      }
    },
    async showManualSelection(){
      if (this.selectedEi.manualSelection) {
        this.priceCategories = await this.getEventInstancePrices(this.selectedEi.eiId);
        const venueObj = await this.$store.dispatch('getSection', this.selectedEi.eiId);
        this.venue = venueObj.venue;
        this.venueTimestamp ++;
        this.initializeWebSocketConnection(this.selectedEi.eiId);
      }
    },
    setSelectionType(type) {
      this.selectionType = type;
      if (type == 1) {
        this.showManualSelection();
      }
    },
    createSelectedEiObj(event, instance) {
      let obj = {};
      obj.eiId = instance.id;
      obj.eId = event.id;
      obj.manualSelection = instance.manualSelection
      obj.prices = [];
      instance.categories.forEach((category) => {
        obj.prices.push({
          price:
            category.fullPrice != null ? category.fullPrice : category.price,
          name: this.capitalized(category.name),
          catId: category.id,
          quantity: 0,
          availableSeats: instance.ticketsLeft
        });
        if (category.promotions) {
          category.promotions.forEach((promo) => {
            obj.prices.push({
              price: promo.price,
              name: this.capitalized(promo.name),
              mention: promo.mention,
              catId: promo.pcdId,
              promoId: promo.id,
              quantity: 0,
              description: promo.description
            });
          });
        }
      });
      return obj;
    },
    removeFromCart(category) {
      const index = this.cartItems.indexOf(category);
      if (index !== -1) {
        this.cartItems.splice(index, 1);
      }
    },
    selectToday() {
      this.selectedDate = this.today;
      this.isTodaySelected = true;
      this.isTomorrowSelected = false;
    },
    selectTomorrow() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.selectedDate = tomorrow;
      this.isTodaySelected = false;
      this.isTomorrowSelected = true;
    },
    async addToCart() {
      this.loading.addToCart = true;
      let totalQ = 0;
      for (let price of this.selectedEi.prices){
        totalQ += price.quantity;
      }
      let selectedTickets = await this.$store.dispatch("selectAndAddToCart", this.selectedEi);
      if (selectedTickets == 0) {
        //TODO - no tickets selected
        console.log(selectedTickets);
        this.$refs.noTicketsModal.openModal();
      } else if (selectedTickets < totalQ){
        //TODO - problem, not all selected
        this.$refs.fewerTicketsModal.openModal();
        console.log(totalQ);
      }
      await this.$store.dispatch("getCart");
      this.resetQuantity();
      this.loading.addToCart = false;
    },
    resetQuantity() {
      if (this.selectedEi != null) {
        this.selectedEi.prices.forEach((price) => {
          price.quantity = 0;
        });
      }
    },
    showImage(image) {
      this.selectedImage = image;
    },
    toggleDescription() {
      this.showFullDescription = !this.showFullDescription;
    },
    truncateDescription(description, lines) {
      if (!description) {
        return "";
      }
      const words = description.split(" ");
      let truncated = words.slice(0, lines * 10).join(" ");
      if (words.length > lines * 10) {
        truncated += "...";
      }
      return truncated;
    },
    openLightbox(image) {
      this.selectedImage = image;
      this.showLightbox = true;
    },
    closeLightbox() {
      this.showLightbox = false;
    },
    addStructuredData() {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.innerHTML = JSON.stringify(this.museumStructuredData);
      document.head.appendChild(script);
    },
    getSeoTitle() {
      if (this.$i18n.locale == 'en'){
        if (this.museumExtraJson.seoTitle_en != null) {
          return this.museumExtraJson.seoTitle_en;
        }
      }
      if (this.museumExtraJson.seoTitle != null) {
        return this.museumExtraJson.seoTitle;
      }
      return this.museum.title;
    },
    getSeoDesc() {
      if (this.$i18n.locale == 'en'){
        if (this.museumExtraJson.seoDesc_en != null) {
          return this.museumExtraJson.seoDesc_en;
        }
      }
      if (this.museumExtraJson.seoDesc != null) {
        return this.museumExtraJson.seoDesc;
      }
      return this.truncateDescription(this.museum.desc, 2);
    },
    getSeoKeywords() {
      if (this.$i18n.locale == 'en'){
        if (this.museumExtraJson.seoKeywords_en != null) {
          return this.museumExtraJson.seoKeywords_en;
        }
      }
      if (this.museumExtraJson.seoKeywords != null) {
        return this.museumExtraJson.seoKeywords;
      }
      return '';
    },
    shouldShowCalendar(ei) {
      if (ei.dateVisibility == EI_SHOW_NOTHING) {
        return false;
      }
      if (ei.dateVisibility == EI_SHOW_DATE && ei.dateEnd != null) {
        let ds = new Date(ei.dateStart);
        let de = new Date(ei.dateEnd);
        if (!sameDay(ds,de)){
            return false;
          }
      }
      return true;
    },
    computeShowEventDescription() {
      const _this = this;
      this.evDescArray = [];
      this.selectedDateEvents.forEach((event) => {
        const key = 'event-desc-' + event.id;
        event.shouldShowButton =
              event.description != null &&
              event.description.length > 0 &&
              _this.$refs[key] != null &&
              _this.$refs[key][0] != null &&
              _this.$refs[key][0].scrollHeight != _this.$refs[key][0].clientHeight;
        this.evDescArray[event.id] = event.shouldShowButton;
      })
      this.descComputed = true;
    },
    toggleEventDesc(event) {
      this.evShowMoreArray[event.id] = !this.evShowMoreArray[event.id];
    },
    findSeat: function (seatId) {
      let foundSeat = null;
      this.venue.sections.forEach(section => {
        section.seats
          .forEach(seat => {
            if (seat.id === seatId) {
              foundSeat = seat;
            }
          });
      });
      return foundSeat;
    },
    getPromotionForSeatId: function (seatId) {
      if (!this.promotions || !this.promotions.single)
        return [];

      const seatPromo = this.promotions.single.find(promo => promo.seatId === seatId);
      if (!seatPromo)
        return [];
      return seatPromo.promotions;
    },
    seatCost: function (seat) {
      if (!seat)
        return 0;

      if (seat.promotion == null && seat.defaultPromotion != null) {
        return seat.defaultPromotion.price;
      }

      if (seat.ticket && typeof seat.ticket.price !== 'undefined')
        return seat.ticket.price;

      if (this.getSeatPcd(seat))
        return this.getSeatPcd(seat).price;

      return 0;
    },
    getSeatLabel: function (seat) {
      let label = '';
      if (seat.sectorLabel !== null && seat.sectorLabel !== 'null' && seat.sectorLabel !== '-' && seat.sectorLabel !== '') {
        label += this.$i18n.t('section') + ' ' + seat.sectorLabel + ' ';
      }
      if (seat.rowLabel !== null && seat.rowLabel !== 'null' && seat.rowLabel !== '-' && seat.rowLabel !== '') {
        label += this.$i18n.t('row') + ' ' + seat.rowLabel + ' ';
      }
      if (seat.label !== null && seat.label !== 'null' && seat.label !== '-' && seat.label !== '') {
        label += this.$i18n.t('seat') + ' ' + seat.label + ' ';
      }
      if (label === '' && this.getSeatPcd(seat) !== null) {
        label += this.getSeatPcd(seat).label + ' ';
      }
      return label.trim();
    },
    clearAllPromotions: function () {
      this.multiplePromotionSelected = null;
      for (const seat of this.actualSelectedSeats)
        seat.promotion = null;
      
      if (this.actualSelectedSeats != null && this.actualSelectedSeats.length > 0){
        this.reservingTickets = true;
        this.addPromotion({ seats: this.actualSelectedSeats, pId: -1 })
        .then(response => {
          if (response != null && response.tickets != null) {
            for (const seat of this.actualSelectedSeats) {
              const ticket = response.tickets.find(t => t.seatId === seat.id);
              seat.ticket = { ...seat.ticket, ...ticket };
            }
          }
        })
        .finally(() => {
          this.reservingTickets = false;
        });
      }
      
    },
    onSelectMultiplePromotion: function (promotion) {
      this.multiplePromotionSelected = promotion;

      this.reservingTickets = true;

      this.addPromotion({ seats: this.actualSelectedSeats, pId: promotion ? promotion.promotionId : -1 })
        .then(response => {
          for (const seat of this.actualSelectedSeats) {
            const ticket = response.tickets.find(t => t.seatId === seat.id);
            seat.ticket = { ...seat.ticket, ...ticket };
            if (ticket.promotionId != null) {
              seat.promotionId = ticket.promotionId;
            }
          }
        })
        .finally(() => {
          this.reservingTickets = false;
        });
    },
    onSelectSingleSeatPromotion: function (seatId, promotion) {
      // Should not allow applying a single promotion if a multiple promotion is selected.
      if (this.multiplePromotionSelected)
        return;

      const seat = this.actualSelectedSeats.find(s => s.id === seatId);
      if (!seat)
        return;

      seat.promotion = promotion;

      this.reservingTickets = true;

      this.addPromotion({ seats: [seat], pId: promotion ? promotion.id : -1 })
        .then(response => {
          seat.ticket = { ...seat.ticket, ...response.tickets[0] };
        })
        .finally(() => {
          this.reservingTickets = false;
          // TO FORCE COMPUTED promotionDetails!
          this.actualSelectedSeats.push({ id: -1 });
          this.actualSelectedSeats.pop();
        });
    },
    getSeatPcd: function (seat) {
      return this.venue.priceCatDefs[seat.priceCat];
    },
    addToSelectedSeats: function (seats) {
      this.actualSelectedSeats.push(...seats);
    },
    removeFromSelectedSeats: function (seats) {
      this.actualSelectedSeats = this.actualSelectedSeats.filter(s => {
        let found = false;
        seats.forEach(seat => {
          if (seat.id === s.id) {
            found = true;
          }
        });
        return !found;
      });
    },
    removeSelectedSeat: async function (seat) {
      this.selectingTickets = true;

      seat.ticket.status = TICKET_FREE;

      seat.fillColor = this.venue.priceCatDefs[seat.priceCat].backgroundColor;
      seat.labelColor = this.venue.priceCatDefs[seat.priceCat].labelColor;
      seat.strokeColor = '#111111';
      seat.canSelect = true;
      seat.shouldAnimate = false;

      const removedSeats = [];
      removedSeats.push(seat);

      try {
        const response = await this.deselectSeat({
          eiId: this.selectedEi.eiId,
          seatId: seat.id
        });
        response.updated.seats.forEach(s => {
          if (s.id !== seat.id) {
            const extraSeat = this.findSeat(s.id);
            extraSeat.ticket.status = TICKET_FREE;
            removedSeats.push(extraSeat);
          }
        })
        this.removeFromSelectedSeats(removedSeats);
      } catch (error) {
          seat.ticket.status = TICKET_DIRTY;
          showToast('error', error.message);
      } finally {
        this.reservingTickets = false;
      }

      this.clearAllPromotions();

      this.promotions = await this.getSeatPromotions(this.actualSelectedSeats);
    },
    claimSeatForUser: function (seat) {
      if (!seat)
        return;

      let defPromo = null;
      if (this.getSeatPcd(seat) != null) {
        this.priceCategories.forEach(category => {
          if (category.id === this.getSeatPcd(seat).id) {
            defPromo = category.defaultPromotion;
          }
        });
      }

      seat.defaultPromotion = defPromo;
      if (!seat.ticket)
        seat.ticket = {};
      seat.ticket.status = TICKET_DIRTY;
      seat.ticket.userId = this.getUser != null ? this.getUser.userId : -1;

      seat.fillColor = '#e74c3c';
      seat.strokeColor = '#c0392b';
      seat.shouldAnimate = true;
      seat.canSelect = true;
    },
    selectMySeat: async function (seat) {
      if (this.actualSelectedSeats.length >= MAX_SELECT_TICKETS)
        return;
      const claimedSeats = [];
      this.claimSeatForUser(seat);
      claimedSeats.push(seat);

      this.selectingTickets = true; //TODO - use this to show a loading spinner or similar

      try {
        let response = await this.selectSeat({
          eiId: this.selectedEi.eiId,
          seatId: seat.id
        });

        if (response.result == 0){
          throw new Error( response.errors);
        }
        response = response.data;
        
        if (!response.updated || response.updated.type !== 10) {
          seat.ticket.status = TICKET_FREE;
          showToast('error', this.$t('maxSeats'));
          return;
        }
        response.updated.seats.forEach(s => {
            const seat = this.findSeat(s.id);
            if (seat) {
              this.claimSeatForUser(seat);
              if (s.id !== seat.id) {
                claimedSeats.push(seat);
              }
            }
        });
        this.addToSelectedSeats(claimedSeats);
      } catch (error) {
          seat.ticket.status = TICKET_FREE;
          seat.fillColor = '#f0f0f0';
          seat.strokeColor = '#dddddd';
          seat.shouldAnimate = false;
          seat.canSelect = false;
          showToast('error', error == null || error.message == "" ? this.$t('selectFail') : error.message);
        
      } finally {
        this.selectingTickets = false;
      }

      if (!this.actualSelectedSeats)
        return;

      this.promotions = await this.getSeatPromotions(this.actualSelectedSeats);
    },
    onClickSeat: async function (seat) {
      this.bestSeatsMessage = '';

      if (seat.ticket.status !== TICKET_DIRTY && seat.ticket.status !== TICKET_FREE)
        return;

      this.numberOfSeatsUserWishesToPurchase = '';

      if (seat.ticket.status !== TICKET_FREE)
        return await this.removeSelectedSeat(seat);

      return await this.selectMySeat(seat);
    },
    findSectionCategory: function (sectionId) {
      return this.availableCategories.find(cat => cat.sectionId === sectionId);
    },
    onSelectFromFlatSection: async function (no, category) {
      this.numberOfSeatsUserWishesToPurchase = no;
      this.onSelectCategory(category);
    },
    clearReservedSeats: function () {
      this.actualSelectedSeats = [];
    },
    onClickAddTicketsToCart () {
      this.reservingTickets = true;
      const _this = this;

      const seats = this.actualSelectedSeats.map(seat => ({ sId: seat.id, pId: seat.promotion ? seat.promotion.id : seat.promotionId }));
      return this.addSeatsToCart(seats)
        .then(function () {
          this.$router.push("/checkout");
        }.bind(this))
        .catch(error => {
          if (error.type === 'conflict') {
            return showToast('error', this.$t('event.cantAddTicketsDueToConflict'));
          }

          showToast('error', error.message);
          
        })
        .finally(() => {
          _this.reservingTickets = false;
        });
    },
    initializeWebSocketConnection: function (eventInstanceId) {

      const socketClient = window.$.atmosphere;
      const webSocketConfig = {
        url: `https://muzeu.ticketsys.ro/refresh/register/${eventInstanceId}`,
        contentType: 'application/json',
        transport: 'websocket',
        fallbackTransport: 'long-polling',
        // onOpen: function (response) {
        //   getDirtySeats TODO.
        // },
        onMessage: this.onReceiveSectionUpdate
      };

      this.socketConnection = socketClient.subscribe(webSocketConfig);
    },
    onReceiveSectionUpdate: function (messageEvent) {
      const eventData = JSON.parse(messageEvent.responseBody);

      if (eventData.eventInstanceId !== this.selectedEi.eiId) {
        return;
      }

      const userId = this.getUser != null ? this.getUser.userId : this.getTempUserId;
      this.venue.sections.forEach(section => {
        section.seats
          .filter(seat => eventData.seats.find(s => s.id === seat.id))
          .forEach(seat => {
            if (seat.ticket != null && (userId !== eventData.sourceUserId)) {
              seat.ticket.status = eventData.type
              seat.ticket.userId = eventData.sourceUserId;
              if (eventData.type === TICKET_DIRTY) {
                seat.fillColor = '#f0f0f0';
                seat.strokeColor = '#dddddd';
                seat.canSelect = false;
              }
              if (eventData.type === TICKET_FREE) {
                seat.fillColor = this.venue.priceCatDefs[seat.priceCat].backgroundColor;
                seat.labelColor = this.venue.priceCatDefs[seat.priceCat].labelColor;
                seat.strokeColor = '#111111';
                seat.canSelect = true;
              }
            }
          });
      })
    }
  },
  watch: {
    async selectedDate(newDate) {
      this.loading.selectDate = true;
      this.selectedHour = null;
      await delay(250);
      if (newDate) {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.isTodaySelected =
          newDate.toDateString() === this.today.toDateString();
        this.isTomorrowSelected =
          newDate.toDateString() === tomorrow.toDateString();
        this.$refs["tickets-select"].scrollIntoView({ behavior: "smooth" });
      } else {
        this.isTodaySelected = false;
        this.isTomorrowSelected = false;
      }
      this.loading.selectDate = false;
      this.descComputed = false;
      let _this = this;
      this.$nextTick(() => {
        if (!_this.descComputed) {
          this.computeShowEventDescription();
        }
      });
    },
    "$refs.quantityInput": {
      deep: true,
      handler() {
        this.checkQuantities();
      },
    },
  },
  computed: {
    ...mapGetters([
    "getEvents", 
    "getMuseums", 
    "getCart", 
    "getCartTickets",
    "getUser",
    "getTempUserId"
  ]),
    getDescByLang() {
      if (this.$i18n.locale == 'en' && this.museumExtraJson.desc_en != null) {
        return this.museumExtraJson.desc_en;
      }
      return this.museumExtraJson.desc;
    },
    getTitleByLang() {
      if (this.$i18n.locale == 'en' && this.museumExtraJson.title_en != null) {
        return this.museumExtraJson.title_en;
      }
      return this.museum.title;
    },
    museumExtraJson() {
      return JSON.parse(this.museum.extraJson || "{}");
    },
    heroImage() {
      if (this.museum.images != null && this.museum.images.length > 0) {
        if (this.museumExtraJson.heroIndex != null && this.museum.images.length > this.museumExtraJson.heroIndex) {
          return this.museum.images[this.museumExtraJson.heroIndex].url;
        }
        return this.museum.images[0].url;
      } else {
        return null;
      }
    },
    images() {
      return this.museum.images;
    },
    showAddToCart() {
      if (!this.selectedEi) {
        return false;
      }
      for (let price of this.selectedEi.prices) {
        if (price.quantity > 0) {
          return true;
        }
      }
      return false;
    },
    imageUrl() {
      if (this.museum.images != null) {
        return this.museum.images[0];
      }
      return "";
    },
    showTodayButton() {
      return this.allowedDates.some(
        (date) => date.toDateString() === this.today.toDateString()
      );
    },
    showTomorrowButton() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return this.allowedDates.some(
        (date) => date.toDateString() === tomorrow.toDateString()
      );
    },
    selectedDateEvents() {
      if (this.events != null && this.events.length > 0) {
        let selectedDateStart;
        let selectedDateEnd;
        if (this.selectedDate) {
          const selectedDate = new Date(this.selectedDate);
          selectedDateStart = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            selectedDate.getDate()
          );
          selectedDateEnd = new Date(
            selectedDateStart.getTime() + 24 * 60 * 60 * 1000 - 1
          );
        }
        let _this = this;
          // console.log(this.events)
        const events = this.events.reduce((acc, event) => {
          event.showFullDescription = false;
          _this.evDescArray[event.id] = false;
          _this.evShowMoreArray[event.id] = false;
          const instances = event.instances.filter((instance) => {
            if (!_this.shouldShowCalendar(instance) || this.events.length == 1 && event.instances.length == 1) {
              return true;
            } else if (_this.selectedDate){
              const instanceStartDate = new Date(instance.dateStart);
              return (
                instanceStartDate >= selectedDateStart &&
                instanceStartDate <= selectedDateEnd
              );
            }
          });
          if (instances.length > 0) {
            acc.push({ ...event, instances });
          }
          return acc;
        }, []);
        if (events.length == 1) {
          let instance = events[0].instances.find(ei => ei.ticketsLeft > 0);
          if (instance != null) {
            console.log("selecting single event instance", events[0].id, instance.id);
            this.selectEi(events[0].id, instance.id);
          }
        }
        this.$nextTick(() => {
          if (!_this.descComputed) {
            this.computeShowEventDescription();
          }
        });
        return events;
      }
      return [];
    },
    /*disabledDates() {
         return this.allowedDates;
      },*/
    minDate() {
      if (this.allowedDates != null) {
        return this.allowedDates[0];
      } else {
        return null;
      }
    },
    maxDate() {
      if (this.allowedDates != null) {
        return this.allowedDates[this.allowedDates.length - 1];
      } else {
        return null;
      }
    },
    disableDate() {
      if (this.allowedDates != null) {
        return [];
      } else {
        //TODO
        return [];
      }
    },
    calendarAttributes() {
      let attributes = [];
      attributes.push({
        key: "allowed",
        dates: this.allowedDates,
        highlight: {
          style: {
            background: "#b0cfff",
          },
          contentStyle: {
            color: "#333",
          },
        },
        selectable: true,
      });
      /*attributes.push({
            key: 'disabled',
            'disabled-dates': (date) => {
             
            },
            disabled: true
          });*/
      if (this.selectedDate != null) {
        attributes.push({
          key: "selected-date",
          highlight: {
            style: {
              background: "rgb(95 46 234)",
            },
            contentStyle: {
              color: "#fff",
            },
          },
          dates: this.selectedDate,
        });
      }
      return attributes;
    },
    museumStructuredData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'Museum',
        name: this.museum.title,
        description: JSON.parse(this.museum.extraJson).desc,
      };
    },
    totalSeatsCost: function () {
      let totalCost = 0;
      for (const seat of this.actualSelectedSeats)
        totalCost += this.seatCost(seat);

      return Math.round(totalCost * 100) / 100;
    },
    selectedSeatsCurrency: function () {
      if (this.actualSelectedSeats.length === 0) {
        return '';
      }
      return this.getSeatPcd(this.actualSelectedSeats[0]).currency;
    },
  },
  updated() {
    feather.replace();
  },
  mounted() {
    feather.replace();
  },
  async created() {
    try {
      await this.$store.dispatch("fetchMuseums");
      this.museum = this.getMuseums.find(
        (museum) =>
          JSON.parse(museum.extraJson).slug === this.$route.params.slug
      );

    this.addStructuredData();
    
    useHead({
      title: this.getSeoTitle(),
      meta: [
        {
          name: `description`,
          content: this.getSeoDesc()
        },
        {
          name: `keywords`,
          content: this.getSeoKeywords()
        }
        ]
    });

      if (this.museum == null) {
        //museum not found
        //TODO
        return;
      }

      if (this.museum.images != null && this.museum.images.length > 0) {
        this.selectedImage = this.museum.images[0];
      }

      if (this.museum.extraJson == null || JSON.parse(this.museum.extraJson).eids == null) {
        this.loading.dates = false;
        return;
      }

      this.eIds = JSON.parse(this.museum.extraJson).eids.split(",").map(Number);

      await this.$store.dispatch("fetchEvents", this.eIds);
      const events = this.$store.getters.getEvents;
      this.events = events;
      let availableDates = [];
      this.showCalendar = false;
      for (let event of events) {
        event.dateVisibility = EI_SHOW_HOUR;
        for (let instance of event.instances) {
          if (instance.dateVisibility == null) {
            instance.dateVisibility = EI_SHOW_HOUR;
          }
          if (this.shouldShowCalendar(instance)) {
            this.showCalendar = true;
          } else {
            event.dateVisibility = instance.dateVisibility;
          }
          let startDate = new Date(instance.dateStart);
          startDate.setHours(0,0,0);
          if (!availableDates.includes(startDate.getTime())) {
            availableDates.push(startDate.getTime());
          }
        }
      }
      availableDates = availableDates.sort().map(d => new Date(d));
      this.allowedDates = availableDates;
      this.shouldShowButton =
        this.getDescByLang != null &&
        this.getDescByLang.length > 0 &&
        this.$refs.desc != null &&
        this.$refs.desc.scrollHeight != this.$refs.desc.clientHeight;

      if (events.length == 1 && events[0].instances.length == 1) {
        this.showCalendar = false;
        console.log("selecting single event instance 2", events[0].id, events[0].instances[0].id);
        this.selectEi(events[0].id, events[0].instances[0].id);
        this.singleEventInstance = true;
      }

      await this.$store.dispatch("getCart");
      this.loading.dates = false;
    } catch (error) {
      console.log(error);
    }
  },
  beforeCreate() {
      const script = document.querySelector('script[type="application/ld+json"]');
      if (script) {
        document.head.removeChild(script);
      }
  },
};
</script>

<style scoped>
.ei-active {
  background-color: red !important;
}

.gallery {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.gallery-item {
  position: relative;
}

.gallery-image {
  width: 100%;
  height: auto;
  border-radius: 10px;
  cursor: pointer;
  max-height: 300px;
}

.thumbnails {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.thumbnail-item {
  margin: 5px;
}

.thumbnail-image {
  width: 80px;
  height: auto;
  cursor: pointer;
}

.cols2grid {
  position: relative;
}

.desc {
  max-height: 210px;
  overflow: hidden;
}

.desc.expanded {
  overflow: visible;
}

.read-more-btn {
  background: none;
  border: none;
  cursor: pointer;
  margin-top: 5px;
  font-weight: 600;
}

.trimmed-text {
  line-height: 1.6;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}

.trimmed-text-min {
  line-height: 1.6;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}

.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  cursor: pointer;
}

.lightbox-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.lightbox-image {
  display: block;
  max-width: 100%;
  max-height: 80vh;
  margin: 0 auto;
}

.lightbox-close {
  position: absolute;
  top: 0px;
  right: 20px;
  font-size: 35px;
  color: #fff;
  cursor: pointer;
}

@media (max-width: 767px) {
  .thumbnails {
    flex-wrap: wrap;
  }
}

/*.vc-highlight-content-solid {
	background-color: #b0cfff!important;
	color: #333!important;
	border: none!important;
	outline: none!important;
}

.vc-day-content:focus {
	background-color: rgb(95 46 234)!important;
	color: #fff!important;
	outline: none!important;
	border: none!important;
}

.vc-highlights {
	border: none!important;
	outline: none!important;
}*/

.desc {
  max-height: unset;
}

.read-more-btn {
  margin-top: 10px;
}

.calendar {
  display: inline-flex;
  column-gap: 20px;
  row-gap: 20px;
  flex-wrap: wrap;
}

.price-entity {
  padding-bottom: 10px;
  padding-top: 10px;
}

.price-entities .price-entity:not(:last-child) {
  border-bottom: 1px solid rgb(228, 218, 255); 
}

.font-size-80 {
  font-size: 80%;
}

.read-more-event-btn {
  float: right;
  font-size: 90%;
}

button:disabled {
  cursor: not-allowed;       /* Dims the button to visually indicate it's disabled */
  background-color: rgb(189 189 189);  /* A greyed-out background color */
  color: #fff;        /* Muted text color */
  border-color: #ccc; /* Match border color to background for consistency */
}

.last-tickets {
  background-color: rgb(238, 180, 35);  /* A greyed-out background color */
  color: #fff;        /* Muted text color */
}

</style>